import { render, staticRenderFns } from "./InfographicChart.vue?vue&type=template&id=8a20b3b4&scoped=true"
import script from "./InfographicChart.vue?vue&type=script&lang=js"
export * from "./InfographicChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a20b3b4",
  null
  
)

export default component.exports